import React, { useState, useEffect } from "react";
import "../Styling-css/SliderForm-PRE.css";
import axios from "axios";

const SliderPreview = ({ onDelete }) => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/sliders`
        );
        setSliders(response.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchSliders();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/sliders/${id}`);
      setSliders(sliders.filter((slide) => slide.id !== id));
      if (onDelete) {
        onDelete(id);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      setError(error);
    }
  };

  if (loading) {
    return <div>Loading sliders...</div>;
  }

  if (error) {
    return <div>Error loading sliders: {error.message}</div>;
  }

  return (
    <div className="slider-container">
      <h3>Slider Preview</h3>
      <hr />
      <div className="preview-cards-container">
        {sliders &&
          sliders.map((slide) => (
            <div key={slide.id} className="preview-card">
              <div className="card-image">
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/slider/${slide.imageUrl}`}
                  alt={slide.title}
                />
              </div>
              <div className="card-content">
                <h4>{slide ? slide.title : "No Title"}</h4>
                <p className="card-description">
                  {slide ? slide.description : "No Description"}
                </p>
                <button
                  className="delete-button"
                  onClick={() =>
                    handleDelete && slide && handleDelete(slide.id)
                  }
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default SliderPreview;
